/** @format */

import React from "react"
import "./Preloader.css"

const ledDivs = [
  "#4efc03",
  "#fc6203",
  "#03a1fc",
  "#03fcbe",
  "#fc037b",
  "#5efc03",
  "#0394fc",
  "#d3fc03",
  "#03fcfc",
  "#9003fc",
  "#b6fc03",
  "#066304",
]

const Preloader = () => {
  return (
    <div className='preloader-main-div'>
      <div className='wrapper'>
        <div className='left-wrapper'></div>
        <div className='right-wrapper'></div>
      </div>
      <div className='preloader-logo-div'>
        <svg
          width='100'
          height='100'
          viewBox='0 0 100 100'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            className='polygone'
            d='M8.69873 26.1547L50 2.3094L91.3013 26.1547V73.8453L50 97.6906L8.69873 73.8453V26.1547Z'
            stroke='#cacfcc'
            strokeWidth='4'
          />
          <path
            className='text'
            d='M58.7532 40.3228C58.5685 38.4608 57.776 37.0143 56.3757 35.9833C54.9754 34.9523 53.0749 34.4368 50.6744 34.4368C49.0432 34.4368 47.666 34.6676 46.5426 35.1293C45.4193 35.5755 44.5575 36.1987 43.9574 36.9989C43.3726 37.7991 43.0803 38.707 43.0803 39.7227C43.0495 40.569 43.2264 41.3076 43.6112 41.9386C44.0112 42.5695 44.5575 43.1158 45.25 43.5774C45.9425 44.0237 46.7427 44.4161 47.6506 44.7546C48.5585 45.0778 49.5279 45.3548 50.559 45.5856L54.8061 46.6012C56.8681 47.0629 58.7609 47.6784 60.4844 48.4478C62.2079 49.2172 63.7005 50.1636 64.9624 51.2869C66.2242 52.4103 67.2014 53.7337 67.8938 55.2571C68.6017 56.7805 68.9633 58.5271 68.9787 60.4968C68.9633 63.3898 68.2247 65.8981 66.7628 68.0217C65.3163 70.1299 63.2235 71.7687 60.4844 72.9382C57.7607 74.0923 54.4753 74.6694 50.6282 74.6694C46.8119 74.6694 43.488 74.0846 40.6566 72.9151C37.8406 71.7456 35.64 70.0144 34.055 67.7216C32.4854 65.4134 31.6622 62.5588 31.5852 59.158H41.2567C41.3645 60.743 41.8184 62.0664 42.6186 63.1282C43.4342 64.1746 44.5191 64.9671 45.8732 65.5057C47.2428 66.0289 48.7893 66.2905 50.5128 66.2905C52.2055 66.2905 53.6751 66.0443 54.9215 65.5518C56.1834 65.0594 57.1605 64.3746 57.853 63.4975C58.5455 62.6204 58.8917 61.6125 58.8917 60.4737C58.8917 59.4119 58.5762 58.5194 57.9453 57.7962C57.3298 57.0729 56.4219 56.4574 55.2216 55.9496C54.0367 55.4418 52.5825 54.9801 50.859 54.5646L45.7116 53.272C41.7261 52.3026 38.5792 50.7868 36.271 48.7248C33.9627 46.6628 32.8163 43.8852 32.8317 40.392C32.8163 37.5298 33.578 35.0292 35.1168 32.8903C36.671 30.7513 38.8023 29.0817 41.5107 27.8814C44.219 26.6811 47.2966 26.081 50.7436 26.081C54.2521 26.081 57.3144 26.6811 59.9304 27.8814C62.5618 29.0817 64.6084 30.7513 66.0703 32.8903C67.5322 35.0292 68.2862 37.5067 68.3324 40.3228H58.7532Z'
            fill='#cacfcc'
          />
          <defs>
            <radialGradient
              id='paint0_radial_2_5'
              cx='0'
              cy='0'
              r='1'
              gradientUnits='userSpaceOnUse'
              gradientTransform='translate(125 15) rotate(135.264) scale(153.444)'>
              <stop stopColor='#4001C6' />
              <stop offset='1' stopColor='#3C0F86' stopOpacity='0' />
            </radialGradient>
            <radialGradient
              id='paint1_radial_2_5'
              cx='0'
              cy='0'
              r='1'
              gradientUnits='userSpaceOnUse'
              gradientTransform='translate(90 19) rotate(116.565) scale(118.512 64.5063)'>
              <stop stopColor='#336E8F' />
              <stop offset='1' stopColor='#00B4CC' stopOpacity='0' />
            </radialGradient>
          </defs>
        </svg>
      </div>
    </div>
  )
}

export default Preloader
